import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { InfoSignInAlertsSpot } from "@gemini/illustrations";
import { Button } from "@gemini/ui";
import { useFormContext } from "react-hook-form";
import { useContactContext } from "@/contexts/contact";
import { useIsMobile } from "@/hooks";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
import { useBrandContext } from "@/shared/contexts";
import { useI18n } from "@/shared/hooks";
export const LoginNudge = () => {
    const { t } = useI18n();
    const { urls: { oauth: oauthUrl }, } = useBrandContext();
    const isMobile = useIsMobile();
    const { userCookieData, isFullNameForm } = useContactContext();
    const { getValues } = useFormContext();
    const { bWindow } = useBrowserAPI();
    const formValues = getValues();
    const userData = Object.assign(Object.assign({}, userCookieData), formValues);
    const handleLoginButtonPress = () => {
        const url = new URL(oauthUrl);
        url.searchParams.set("m", "classified_detail_lead_confirmation_login_nudge_account_login");
        url.searchParams.set("redirect_uri", bWindow.location.href);
        bWindow.location.href = url.toString();
    };
    return (_jsxs(Box, { width: {
            "breakpoint.base": "calc(100% - 32px)",
            "breakpoint.md": "calc(100% - 48px)",
            "breakpoint.lg": "738px",
        }, display: "flex", flexDirection: "column", alignSelf: "center", alignItems: {
            "breakpoint.base": "flex-start",
            "breakpoint.sm": "center",
        }, gap: "spacing.24", paddingVertical: {
            "breakpoint.base": "spacing.32",
        }, paddingHorizontal: "spacing.none", borderColor: "color.surface.transparent.default", borderTopColor: "color.surface.subdued.default", borderBottomColor: {
            "breakpoint.base": "color.surface.subdued.default",
            "breakpoint.lg": "color.surface.transparent.default",
        }, borderWidth: "borderWidth.1", borderStyle: "solid", children: [_jsx(Box, { typography: "typography.headline.24.bold", children: t("contact.form.login_box.title") }), _jsxs(Box, { minWidth: {
                    "breakpoint.base": "100%",
                }, position: "relative", display: "flex", flexDirection: "column", padding: "spacing.16", gap: "spacing.16", borderRadius: "radius.16", borderWidth: "borderWidth.1", borderColor: "color.border.transparent.default", borderStyle: "solid", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", width: "100%", children: [_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.4", children: [_jsx(Box, { minHeight: "24px", verticalAlign: "middle", typography: "typography.body.16.bold", children: isFullNameForm
                                            ? userData === null || userData === void 0 ? void 0 : userData.fullName
                                            : `${userData === null || userData === void 0 ? void 0 : userData.firstName} ${userData === null || userData === void 0 ? void 0 : userData.lastName}` }), _jsx(Box, { minHeight: "18px", verticalAlign: "middle", typography: "typography.body.14.regular", children: userData === null || userData === void 0 ? void 0 : userData.email }), _jsx(Box, { minHeight: "20px", verticalAlign: "middle", typography: "typography.body.14.regular", children: userData === null || userData === void 0 ? void 0 : userData.phoneNumber })] }), _jsx(Box, { position: {
                                    "breakpoint.base": "relative",
                                    "breakpoint.sm": "absolute",
                                }, right: "0", top: {
                                    "breakpoint.base": "0px",
                                    "breakpoint.sm": "13px",
                                }, children: _jsx(InfoSignInAlertsSpot, { size: isMobile ? "72" : "96", "aria-label": "Sign in info alert" }) })] }), _jsx(Box, { display: "flex", justifyContent: "space-between", width: {
                            "breakpoint.base": "100%",
                            "breakpoint.sm": "50%",
                        }, children: _jsx(Button, { isFullWidth: {
                                "breakpoint.base": true,
                                "breakpoint.sm": false,
                            }, variant: "secondary", onPress: handleLoginButtonPress, children: t("contact.form.login_box.button_text") }) })] })] }));
};
